const INPUT_DEBOUNCE_TIME_MS_DEFAULT = 500;
const STRIPE_ACCOUNT_COUNTRY_CODE = 'GB';

const CURRENCIES = {
  POUND_STERLING: 'gbp',
  UNITED_STATE_DOLLAR: 'usd',
  EURO: 'eur',
  CANADIAN_DOLLAR: 'cad',
  AUSTRALIAN_DOLLAR: 'aud',
  UNITED_ARAB_EMIRATES_DIRHAM: 'aed',
};

// https://stripe.com/docs/currencies#minimum-and-maximum-charge-amounts
const MINIMAL_PAYMENT_AMOUNT = {
  [CURRENCIES.POUND_STERLING]: 1, // £0.30 before
  [CURRENCIES.AUSTRALIAN_DOLLAR]: 1, // $0.50 before
  [CURRENCIES.CANADIAN_DOLLAR]: 1, // $0.50 before
  [CURRENCIES.EURO]: 1, // €0.50 before
  [CURRENCIES.UNITED_ARAB_EMIRATES_DIRHAM]: 4, // 2.00 د.إ before
  [CURRENCIES.UNITED_STATE_DOLLAR]: 1, // $0.50 before
};

// https://stripe.com/docs/currencies#minimum-and-maximum-charge-amounts
const MAX_PAYMENT_AMOUNT = 99999999;

const COMMUNITY_URL = 'https://community.tryb.cc';

const CALENDLY_URL = 'https://calendly.com/trybdaniel';
const CALENDLY_ONBOARDING_CALL_URL = `${CALENDLY_URL}/call-with-daniel`;

const ANALYTICS_GENERATION_INTERVAL_MS = 120000; // 2 min
const ANALYTICS_GENERATION_LAG_MS = 20000; // 20 sec

const MAX_TITLE_INPUT_LENGTH = 100;

export {
  INPUT_DEBOUNCE_TIME_MS_DEFAULT,
  STRIPE_ACCOUNT_COUNTRY_CODE,
  CURRENCIES,
  MINIMAL_PAYMENT_AMOUNT,
  MAX_PAYMENT_AMOUNT,
  COMMUNITY_URL,
  CALENDLY_URL,
  CALENDLY_ONBOARDING_CALL_URL,
  ANALYTICS_GENERATION_INTERVAL_MS,
  ANALYTICS_GENERATION_LAG_MS,
  MAX_TITLE_INPUT_LENGTH,
};
